module.exports = __webpack_public_path__ + "img/img-live-notice.ffb22507.png";